if (typeof window !== 'undefined') {
  var WebFont = require('webfontloader');

  WebFont.load({
    google: {
      families: ['Montserrat:300,400,500,700', 'sans-serif']
    }
  });
}

export var PlayfairDisplay = '"Playfair Display", serif';
export var Montserrat = '"Montserrat", sans-serif';
export var ProximaNova = '"proxima-nova", sans-serif';